function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-4{fill-rule:evenodd;fill:#fefefe}"), React.createElement("mask", {
  id: "mask",
  x: -27,
  y: -7.04,
  width: 185,
  height: 33,
  maskUnits: "userSpaceOnUse"
}, React.createElement("path", {
  fill: "#fff",
  d: "M-27-7.04h185v33H-27z",
  id: "mask0"
})), React.createElement("mask", {
  id: "mask-2",
  x: 94.23,
  y: 5.28,
  width: 10.3,
  height: 11.05,
  maskUnits: "userSpaceOnUse"
}, React.createElement("path", {
  d: "M94.23 5.28h10.3v11h-10.3z",
  fillRule: "evenodd",
  fill: "#fff",
  id: "mask1"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#mask)"
}, React.createElement("path", {
  className: "cls-4",
  d: "M0 8c0-4.26 2.8-8 7-8s7 3.74 7 8c0 4.22-2.8 8-7 8s-7-3.77-7-8zm12.93 0c0-3.82-2.51-7-5.95-7S1.07 4.09 1.07 7.92V8c0 3.82 2.51 7 5.95 7s5.91-3.17 5.91-7zM24 1h1l6 8.87L37 1h1v15h-1.1V3L31 11.57h-.08l-5.86-8.64V16H24zM49 1h9.9v1H50v5.88h8v1h-8v6h9v1H49zM68 1h1l10 13V1h1v15h-.8L69 2.63V16h-1zM85.29 12.3v.6H85V9h.29v1.8a1.48 1.48 0 0 1 1.24-.68A1.44 1.44 0 0 1 88 11.51 1.44 1.44 0 0 1 86.53 13a1.47 1.47 0 0 1-1.24-.7zm2.4-.77a1.15 1.15 0 0 0-1.19-1.18 1.21 1.21 0 0 0-1.23 1.18 1.21 1.21 0 0 0 1.23 1.18 1.13 1.13 0 0 0 1.19-1.18zM91.68 10H92l-1.31 3.1c-.26.64-.57.86-1 .86a1.35 1.35 0 0 1-.6-.13l.1-.26a1 1 0 0 0 .51.12c.32 0 .52-.19.75-.72L89 10h.34l1.25 2.71z"
}), React.createElement("g", {
  mask: "url(#mask-2)"
}, React.createElement("path", {
  className: "cls-4",
  d: "M99.38 16.33h-.16l1.06-3.11h1.44a.71.71 0 0 0 .63-.46l1.14-3.37a.7.7 0 0 0-.66-1h-2l-1.68 5-1 2.82a5.46 5.46 0 0 1-4-5.37A5.47 5.47 0 0 1 98 5.49l-1 2.9-1.64 4.83h1.09l1.4-4.1h.82l-1.4 4.1h1.09l1.3-3.83a.69.69 0 0 0-.65-1h-.92l1-3.1h.24a5.35 5.35 0 0 1 5.15 5.53 5.35 5.35 0 0 1-5.1 5.51zm3.11-7.21h-.82l-1.15 3.38h.82z"
})));

var SvgOmen = function SvgOmen(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 104.53 16.33",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOmen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/omen.b7185fca.svg";
export { ForwardRef as ReactComponent };